export const CYBER_TIPS_BASE_PATHS = ["fincantieri", "cyber-tips-cdp"];

export const isCyberTipsSection = (basePath) =>
  CYBER_TIPS_BASE_PATHS.includes(basePath);

export const getCyberTipsEntityLabel = ({ plural = false } = {}) =>
  plural ? "Tips" : "Tip";
